export class BaseTrasitions {
    transitions? :Map<string, any>;
    constructor(transitions?: Map<string, any>) {
        this.transitions = transitions;
    }
}
  